/***
 * 创建人：张丽莉
 * 时间：2022-09-30
 * 描述: 工作台的待发列表 显示前五条
 * 更新说明:
 */
import { Component, OnInit, ComponentFactoryResolver, Input} from '@angular/core';
import { Router } from '@angular/router';
import { ProcessToDosService } from 'src/app/librarys/serves/public/process-to-dos.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { BdpEnum } from 'src/app/areas/bdp/serves/bdp-enum';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';

/**
 * 工作台显示待发数据 默认显示前五条  sw-process-to-publish-table
 */
@Component({
  selector: 'sw-process-to-publish-table',
  templateUrl: './sw-process-to-publish-table.component.html',
  styleUrls: ['./sw-process-to-publish-table.component.css']
})
export class SwProcessToPublishTableComponent implements OnInit {

  /**
   * @ignore
   * @param router
   * @param process
   */
  constructor( 
    private router: Router,
    private process:ProcessToDosService,
    private Jwt: SwJwtService,
    private create:SwCreateModalComponentService,
    private cfr: ComponentFactoryResolver,
    private box: SwMassageBoxService, //消息服务
    private http: SwHttpClientService, //http 请求服务
    private systemId:SystemIdService,
    ) { }

  /**
   * @ignore
   * 数据表基础信息
   */
  infoList:any=[];
  
  isLoading:boolean=true;
  /**
  * 输入属性--是否待办列表字段有更多按钮,默认有
  */
  @Input() hasMore:boolean = true
  /**
  * 样式类型，默认为1
  */
 @Input() type:any = 1
  /**
   * @ignore
   */
  ngOnInit() {
    this.getTask();
    this.infoList = []  //之前的 this.getTask() 的里面虽然已经获取到了已发列表,但是工作台刷新时,没有刷新效果,所以下面重新将 infoList 清空, 再调用 this.process.oninitPublishedToDos() 方法,重新调接口获取已发,然后由 getTask() 中刷新数据
    this.process.oninitToPublish()
  }

  /**
   * 查看待办内容
   * @ignore
   */
  outSelectData(data) {
    let param = {
      businessKey: data.keyWord + ":" + data.businessId,
      firstSid: data.firstSid,
      procInstId:data.procInstId || undefined,
      formId: data.formId,
      version: data.version
    };
    if(data.openType == 1){ 
      //如果打开方式是 tab页 的话
      if(data.submitUrl == '/oa/DynamicFormRender'){
        this.router.navigate(['/oa/DynamicFormRender/'+data['formId']], { queryParams: { Title: data.flowName,Operate: BdpEnum.SYS_PROCESS_UPDATE,  data: JSON.stringify(param)}});
      }else {
        this.router.navigate([data.submitUrl], { queryParams: { Title: data.flowName,Operate: BdpEnum.SYS_PROCESS_UPDATE,  data: JSON.stringify(param)}});
      }
     
    } else if(data.openType == 2){
      //如果是用模态框打开
      let fact = this.cfr["_factories"]
      //对参数进行处理
      let modalParam = data.params ? JSON.parse(data.params) : {}
      let queryParams = { Title: data.flowName,Operate: BdpEnum.SYS_PROCESS_UPDATE,  data: JSON.stringify(param)}
      let params = {param: modalParam,queryParams: queryParams}
      fact.forEach((value:any,key:any)=>{
        if(value.selector == data.submitUrl){
          this.create.createModal(key,params,this.getToPublishProcessList.bind(this))
        }
      })
    }
  }

  getToPublishProcessList(){
    this.process.oninitToPublish()
  }

  /**
   * 获取所有已发信息前五条
   * @ignore
   */
  getTask() {
    //首先 查看 初始化化方法是否以及获取到数据
    if(this.process.toPublishList){
      //如果获取到 则将数据赋值
      this.infoList =this.process.toPublishList.records;
    }
    //这是是已发的订阅属性
    this.process.toPublishUpdated.subscribe((val)=>{
      //如果接受到数据
      //重新获取数据
      this.isLoading=false;
      this.infoList = val.records;
    })



  }
  /**
   * 查看更多页面
   * @ignore
   */
  clickView(){
    this.router.navigate(['oa/ToPublishProcess'], {queryParams: {Title: '待发流程'}});
  }

}
